
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogo",
      function () {
        return require("private-next-pages/catalogo/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogo"])
      });
    }
  